import { render, staticRenderFns } from "./formDialog.vue?vue&type=template&id=6bdae8f3&"
import script from "./formDialog.vue?vue&type=script&lang=js&"
export * from "./formDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/nisems/front/nisbos-front-admin/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bdae8f3')) {
      api.createRecord('6bdae8f3', component.options)
    } else {
      api.reload('6bdae8f3', component.options)
    }
    module.hot.accept("./formDialog.vue?vue&type=template&id=6bdae8f3&", function () {
      api.rerender('6bdae8f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialog/formDialog.vue"
export default component.exports